<template>
    <div>
        <van-nav-bar
            class="nav_bar"
            title=""
            left-arrow
            :fixed="true"
            @click-left="onClickLeft"
            />
        <div class="banner">
            <img src="" alt="">
        </div>
        <div class="rank-box">
            <div class="rank-list">
                <div class="rank-title">
                    <h3>总排行榜</h3>
                    <div class="rank-title-box">
                        <van-field
                            clickable
                            readonly
                            name="area"
                            :value="areacls"
                            placeholder="点击选择"
                            @click="show = true"
                            class="small-box"
                        />
                        <van-popup v-model="show" position="bottom">
                            <van-picker
                                show-toolbar
                                :default-index="1"
                                :columns="cls"
                                @confirm="confirm"
                                @cancel="show = false"
                            />
                        </van-popup>
                    </div>
                </div>
                <div class="cls-a-box">
                    <div class="second cls-a">
                        <div class="cls-a-content">
                            <div class="cls-a-content-avatar">
                                <img :src="list && list.length>1 && list[1].headImage || 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank-user.png'" alt="" class="avatar">
                                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank2-icon.png" alt="" class="icon">
                            </div>
                            <p class="name">{{ list && list.length>1 && list[1].name || '--' }}</p>
                            <p class="point-box"><span>积分：</span><span class="points">{{ list && list.length>1 && list[1].points || '--' }}</span></p>
                            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank2.png" alt="" class="cls-num">
                        </div>
                    </div>
                    <div class="first cls-a">
                        <div class="cls-a-content">
                            <div class="cls-a-content-avatar">
                                <img :src="list && list.length>0 && list[0].headImage || 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank-user.png'" alt="" class="avatar">
                                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank1-icon.png" alt="" class="icon">
                            </div>
                            <p class="name">{{ list && list.length>0 && list[0].name || '--' }}</p>
                            <p class="point-box"><span>积分：</span><span class="points">{{ list && list.length>0 && list[0].points  || '--'}}</span></p>
                            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank1.png" alt="" class="cls-num">
                        </div>
                    </div>
                    <div class="third cls-a">
                        <div class="cls-a-content">
                            <div class="cls-a-content-avatar">
                                <img :src="list && list.length>2 && list[2].headImage || 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank-user.png'" alt="" class="avatar">
                                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank3-icon.png" alt="" class="icon">
                            </div>
                            <p class="name">{{ list && list.length>2 && list[2].name || '--' }}</p>
                            <p class="point-box"><span>积分：</span><span class="points">{{ list && list.length>2 && list[2].points || '--'}}</span></p>
                            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank3.png" alt="" class="cls-num">
                        </div>
                    </div>
                </div>
                <ul>
                    <li>
                        <span>排名</span>
                        <span>姓名</span>
                        <span>手机号</span>
                        <span>所属省份</span>
                        <span>积分</span>
                    </li>
                    <li v-for="(item,index) in list" :key="item.user_id">
                        <span>{{ index+1 }}</span>
                        <span>{{ item.name }}</span>
                        <span>{{ item.phone }}</span>
                        <span>{{ provinceList?.province_list && provinceList.province_list[+item.areaCode] || '--' }}</span>
                        <span>{{ item.points }}</span>
                    </li>
                    <empty-data v-if="list && list.length==0"></empty-data>
                </ul>
            </div>
            <div class="rank-list">
                <div class="rank-title">
                    <h3>省排行榜</h3>
                    <div class="rank-title-box">
                        <van-field
                            readonly
                            clickable
                            name="area"
                            :value="province"
                            placeholder="点击选择"
                            @click="showArea = true"
                        />
                        <van-popup v-model="showArea" position="bottom">
                            <van-area
                            :columns-num="1"
                            :area-list="provinceList"
                            @confirm="onConfirm"
                            @cancel="showArea = false"
                            />
                        </van-popup>
                        <van-field
                            readonly
                            clickable
                            name="area"
                            :value="provincecls"
                            placeholder="点击选择"
                            @click="show2 = true"
                            class="small-box"
                        />
                        <van-popup v-model="show2" position="bottom">
                            <van-picker
                                :default-index="1"
                                show-toolbar
                                :columns="cls"
                                @confirm="confirm2"
                                @cancel="show2 = false"
                            />
                        </van-popup>
                    </div>
                </div>
                <div class="cls-a-box">
                    <div class="second cls-a">
                        <div class="cls-a-content">
                            <div class="cls-a-content-avatar">
                                <img :src="list2 && list2.length>1 && list2[1].headImage || 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank-user.png'" alt="" class="avatar">
                                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank2-icon.png" alt="" class="icon">
                            </div>
                            <p class="name">{{ list2 && list2.length>1 && list2[1].name || '--' }}</p>
                            <p class="point-box"><span>积分：</span><span class="points">{{ list2 && list2.length>1 && list2[1].points || '--' }}</span></p>
                            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank2.png" alt="" class="cls-num">
                        </div>
                    </div>
                    <div class="first cls-a">
                        <div class="cls-a-content">
                            <div class="cls-a-content-avatar">
                                <img :src="list2 && list2.length>0 && list2[0].headImage || 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank-user.png'" alt="" class="avatar">
                                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank1-icon.png" alt="" class="icon">
                            </div>
                            <p class="name">{{ list2 && list2.length>0 && list2[0].name || '--'}}</p>
                            <p class="point-box"><span>积分：</span><span class="points">{{ list2 && list2.length>0 && list2[0].points  || '--'}}</span></p>
                            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank1.png" alt="" class="cls-num">
                        </div>
                    </div>
                    <div class="third cls-a">
                        <div class="cls-a-content">
                            <div class="cls-a-content-avatar">
                                <img :src="list2 && list2.length>2 && list2[2].headImage || 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank-user.png'" alt="" class="avatar">
                                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank3-icon.png" alt="" class="icon">
                            </div>
                            <p class="name">{{ list2 && list2.length>2 && list2[2].name || '--'}}</p>
                            <p class="point-box"><span>积分：</span><span class="points">{{ list2 && list2.length>2 && list2[2].points || '--'}}</span></p>
                            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank3.png" alt="" class="cls-num">
                        </div>
                    </div>
                </div>
                <ul>
                    <li>
                        <span>排名</span>
                        <span>姓名</span>
                        <span>手机号</span>
                        <span>所属省份</span>
                        <span>积分</span>
                    </li>
                    <li v-for="(item,index) in list2" :key="item.user_id">
                        <span>{{ index+1 }}</span>
                        <span>{{ item.name }}</span>
                        <span>{{ item.phone }}</span>
                        <span>{{ provinceList?.province_list && provinceList.province_list[+item.areaCode] || '--' }}</span>
                        <span>{{ item.points }}</span>
                    </li>
                    <empty-data v-if="list2 && list2.length==0"></empty-data>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import EmptyData from '../../layout/empty-data.vue';
export default{
    name:'rank',
    data(){
        return{
            show:false,
            show2:false,
            showArea:false,
            provincecls:'前10名',
            areacls:'前10名',
            provinceclsIndex:10,
            areaclsIndex:10,
            province:'',
            provinceCode:'',
            provinceList: {
                province_list: {},
                city_list: {},
                county_list: {},
            }, // 数据格
            cls:[
                '前10名','前20名','前30名'
            ],
            list:null,
            list2:null
        }
    },
    components:{
        EmptyData
    },
    created(){
        const userInfo = localStorage.getItem("subUserInfo") && JSON.parse(localStorage.getItem("subUserInfo"));
        this.provinceCode = userInfo?.areaCode;
        this.getRegionList();
        this.getData();
    },
    methods:{
        confirm(values,index){
            this.areacls = values;
            this.areaclsIndex = (index+1)*10;
            this.show = false;
            this.getData();
        },
        confirm2(values,index){
            this.provincecls = values;
            this.provinceclsIndex = (index+1)*10;
            this.show2 = false;
            this.getData2();
        },
        async getRegionList() {
            await this.$api.usercenter.getTree({ type: 1 }).then((res) => {
                if (res.success && res.data) {
                    let filterArr = res.data.filter((item) => {
                        return item.code.length === 2 && item.children;
                    });
                    let uniqueArr = Array.from(new Set(filterArr));
                    // 切换成vant省市组件格式
                    uniqueArr.map((item) => {
                        this.provinceList.province_list[item.code] = item.name;
                        item.children.map((province) => {
                            this.provinceList.city_list[province.code] = province.name;
                            (province.children || []).map((county) => {
                                this.provinceList.county_list[county.code] = county.name;
                            });
                        });
                    });
                    if(!this.provinceCode){
                        this.provinceCode = 11;
                    }
                    this.province = this.provinceList.province_list[this.provinceCode];
                    this.getData2();
                }
            });
        },
        // 省市选择
        onConfirm(values) {
            this.province = values
                .filter((item) => !!item)
                .map((item) => item.name)
                .join("/");
            this.provinceCode = values[0].code;
            this.showArea = false;
            this.getData2();
        },
        getData(){
            const params = {
                size:this.areaclsIndex,
            }
            this.$api.rank.rankPoint(params).then(res=>{
                if(res.data){
                    this.list = res.data || [];
                }
            })
        },
        getData2(){
            const params = {
                size:this.provinceclsIndex,
                code:this.provinceCode
            }
            this.$api.rank.rankPoint(params).then(res=>{
                if(res.data){
                    this.list2 = res.data || [];
                }
            })
        },
        onClickLeft(){
            this.$router.go(-1);
        }
    }
}
</script>
<style lang="stylus" scoped>
::v-deep div.van-nav-bar--fixed{
    position:fixed;
    background:transparent;
    &::after{
        border:none;
    }
}
.banner{
    height: 380px;
    background: url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/multipurpose-honghui/rank-banner-h5.png') no-repeat center bottom;
    background-size:cover;
}
h3{
    font-size: 32px;
    line-height: 32px;
    margin-bottom: 103px;
}
.cls-a-box{
    height: 171px;
    display: flex;
    justify-content: space-between;
}
.cls-a{
    width:196px;
    height: 156px;
    border-radius: 8px;
    .cls-a-content{
        margin: -45px auto 0;
        position relative;
        text-align: center;
        .cls-a-content-avatar{
            position:relative;
            width:84px;
            margin: 0 auto;
        }
        p{
            font-size:23px;
        }
        .avatar{
            width:84px;
            height: 84px;
            vertical-align: middle;
            border-radius: 50%;
            object-fit: cover;
        }
        .icon{
            position:absolute;
            top:-10px;
            width:33px;
            height: 33px;
            right: -8px;
        }
        span{
            font-size: 26px;
            line-height: 28px;
            color: #666;
        }
        .name{
            font-weight: 600;
            margin-top: 24px;
            line-height: 28px;
            font-size:24px;
            white-space: nowrap; /* 不换行 */
            overflow: hidden; /* 隐藏超出的内容 */
            text-overflow: ellipsis;
            padding:0 10px;
        }
        .points{
            color: #FF7A4C;
            font-weight: 600;
        }
        .point-box{
            margin-top: 16px;
            line-height: 17px;
        }
        .cls-num{
            width:42px;
            height: 51px;
            position:absolute;
            right:15px;
            top:54px;
        }
    }
    &:nth-child(2){
        margin-top: -24px;
    }
    &.second{
        background: linear-gradient( 180deg, #ECECEC 0%, #FDFDFD 100%);
    }
    &.first{
        background: linear-gradient( 180deg, #FFF8EC 0%, #FFFFFD 100%);
        .cls-num{
            height:58px;
            width:34px;
        }
    }
    &.third{
        background: linear-gradient( 180deg, #FFF5F0 0%, #FFFDFD 100%);
    }
}
.rank-title-box{
    display: flex;
    align-items: flex-start;
}
.rank-title{
    display: flex;
    justify-content: space-between;
    div.small-box{
        width:130px;
    }
    ::v-deep .van-cell{
        width:110px;
        margin-left:6px;
        line-height:12px;
        padding:4px 7px;
        border: 1px solid #E1E1E1;
        background: #F0F0F0;
        font-weight:600;
        color:#333;
        font-size:12px;
        border-radius:4px;
        input[type=text]:focus, input[type=password]:focus, textarea:focus{
            box-shadow:none;
        }
    }
    ::v-deep .el-input__inner{
        height:28px;
        line-height:28px;
        
        width:146px;
        
    }
    h3{
        margin-top:6px;
    }
    ::v-deep .el-input__icon{
        line-height:28px;
    }
}
.rank-box{
    padding:0 32px 44px;
    .rank-list{
        background: #fff;
        border-radius: 16px;
        box-shadow: 0px 22px 35px 0px rgba(234,235,238,0.77);
        padding:20px 24px 0;
        box-sizing: border-box;
        min-height: 916px;
        margin-bottom:24px;
        &:nth-child(1){
            margin-top:-115px;
        }
    }
    ul{
        li{
            padding: 24px 0;
            text-align: center;
            border-bottom:1px solid #DCE1E9;
            font-size:12px;
            &:nth-last-child(1){
                border:none;
            }
            span{
                display: inline-block;
                font-size:22px;
                line-height: 22px;
                &:nth-child(1){
                    width:65px;
                    font-weight: 500;
                }
                &:nth-child(2){
                    width:150px;
                    text-align: left;
                    padding-left: 16px;
                    box-sizing: border-box;
                    display: inline-block;
                    white-space: nowrap; /* 不换行 */
                    overflow: hidden; /* 隐藏超出的内容 */
                    text-overflow: ellipsis; 
                    img{
                        height: 20px;
                        width:20px;
                        border-radius: 50%;
                        object-fit: cover;
                        margin-right: 3px;
                        align-items: center;
                        vertical-align: middle;
                    }
                }
                &:nth-child(3){
                    width:160px;
                }
                &:nth-child(4){
                    width:180px;
                    white-space: nowrap; /* 不换行 */
                    overflow: hidden; /* 隐藏超出的内容 */
                    text-overflow: ellipsis; 
                }
                &:nth-child(5){
                    width:65px;
                    font-weight:600;
                }
            }
            &:nth-child(1){
                height: 72px;
                padding:0;
                line-height: 72px;
                background: #F0F1F6;
                font-size: 24px;
                font-weight: 600;
                color: #333;
                border: none;
                span{
                    font-size:24px;
                    &:nth-child(1){
                        font-weight: 600;
                    }
                    &:nth-child(2){
                        text-align: center;
                    }
                }
            }
        }
    }
}
</style>